window.mindfulchefAccountDelink = (function ($) {
    window.dataLayer = window.dataLayer || [];
    const self = {
        elements: {
            delinkButton: '#open-delink-modal-button',
            confirmDelinkButton: '#mindfulchef-account-delink',
            loadingNotification: '#mindfulchef-account-delink-loading',
            errorNotification: '#mindfulchef-account-delink-error',
        },
        urls: {
            accountDelink: '/api/sitecore/MindfulChefEnrolment/AccountDelink',
            errorPage: '/error/error-page'
        },
        func: {
            init: function () {
                self.func.bindings();
            },
            bindings: function () {
                $(self.elements.confirmDelinkButton).on('click', self.func.accountDelink);
            },
            accountDelink: function (event) {
                window.Utilities.func.closeModal($(self.elements.delinkButton).data('openmodal'));
                window.Utilities.func.openModal($(self.elements.delinkButton).data('delinkloadingmodal'));
                event.preventDefault();
                $.ajax({
                    method: 'POST',
                    url: self.urls.accountDelink,
                    success: function (success) {
                        if (success) {
                            window.location = window.location.pathname;
                            $(window).scrollTop(0);
                        } else {
                            window.Utilities.func.closeModal($(self.elements.delinkButton).data('delinkloadingmodal'));
                            window.Utilities.func.openModal($(self.elements.delinkButton).data('delinkfailedmodal'));
                        }
                    },
                    error: function () {
                        window.location.replace(self.urls.errorPage);
                    }
                });
            }
        }
    };
    return {
        init: self.func.init
    };
})(jQuery);

$('document').ready(function () {
    if ($('#mindfulchef-account-delink').length > 0) {
        window.mindfulchefAccountDelink.init();
    }
});
